<template>
  <div id="mainKari">
    <div class="banner">
      <div class="content align">
        <div class="inner">
          <h1>Делите стоимость любой покупки на 4 или 6 платежей</h1>
          <p>Позвольте себе больше. Оплачивайте часть<br class="PC"> суммы покупки сразу, остальное потом.</p>
          <button class="purpleButton" v-on:click="scroll('howToBuy')">Как купить</button>
        </div>
        <img src="../assets/svg/bannerPart.png" class="PC"/>
      </div>
    </div>

    <div class="advantages">
      <div class="advBlock">
        <img alt="" src="../assets/svg/timerImage.png"/>
        <h3 class="title">Быстро</h3>
        <p class="description">Как обычная оплата картой</p>
      </div>
      <div class="advBlock">
        <img alt="" src="../assets/svg/phoneImage.png"/>
        <h3 class="title">Легко</h3>
        <p class="description">Достаточно указать номер телефона</p>
      </div>
      <div class="advBlock">
        <img alt="" src="../assets/svg/cardsImage.png"/>
        <h3 class="title">Выгодно</h3>
        <p class="description">Нет скрытых платежей</p>
      </div>
      <div class="advBlock">
        <img alt="" src="../assets/svg/bagsImage.png"/>
        <h3 class="title">Удобно</h3>
        <p class="description">Покупайте сразу, <br> а платите частями</p>
      </div>
    </div>

    <div class="parts align" id="howToUse">

      <h2 id="howToBuy">Как покупать выгодно с kari частями</h2>

      <div class="part">
        <p class="num">01</p>
        <div class="text">
          <h3>Определитесь с покупкой и выберите оплату частями</h3>
          <p><a href="https://redirect.appmetrica.yandex.com/serve/460661648240177480">В приложении kari</a>, находясь в магазине или на кассе магазина по ссылке из смс</p>
        </div>

        <img alt="" src="../assets/svg/Illustr1.png">
      </div>

      <div class="part">
        <p class="num">02</p>
        <div class="part2content">
          <h3>Укажите ваш номер телефона и выберите удобный для вас график<br class="PC"> платежей</h3>
          <div class="subParts">
            <div class="subPart">
              <h1>25% сразу</h1>
              <long-dotted-line/>
              <p>Остальное 3 платежами каждые 2 недели</p>
<!--              <a>Выбрать</a>-->
            </div>

            <div class="subPart">
              <h1>25% сразу</h1>
              <long-dotted-line/>
              <p>Остальное 3 платежами каждый месяц</p>
<!--              <a>Выбрать</a>-->
            </div>

            <div class="subPart">
              <h1>20% сразу</h1>
              <short-dotted-line/>
              <p>Остальное 5 платежами каждый месяц</p>
<!--              <a>Выбрать</a>-->
            </div>
          </div>
        </div>
      </div>

      <div class="part">
        <p class="num">03</p>
        <div class="text">
          <h3>Оплачивайте в личном кабинете или в приложении kari</h3>
          <p class="lh">Следующие платежи оплачивайте по карте<br class="mobile"> любого банка<br> в приложении kari или в личном кабинете.<br class="mobile"> Оплатить можно привязанной картой, СБП, на<br class="mobile"> расчетный счет</p>
<!--          <div class="link"><a>Перейти в приложение</a></div>-->
          <div class="link" v-on:click="setPopUp(10)"><a>Реквизиты счета</a></div>
        </div>
        <img alt="" src="../assets/svg/Illustr2.png">
      </div>

    </div>

    <div class="prilog">

      <div class="prilCont align">
        <h2 class="mobile">Скачайте приложение kari по ссылке</h2>
        <h2 class="PC">Скачайте приложение kari<br> по ссылке или QR-коду</h2>

        <ul class="points">
          <li>множество товаров по доступным ценам</li>
          <li>быстрое оформление</li>
          <li>удобный график платежей</li>
          <li>чат с поддержкой</li>
        </ul>

        <div class="buttons">
          <div class="appButton" v-on:click="linkTo('https://play.google.com/store/apps/details?id=ru.kari.android')"></div>
          <div class="appButton" v-on:click="linkTo('https://apps.apple.com/ru/app/kari-обувь-и-аксессуары/id1497875223')"></div>
          <div class="appButton" v-on:click="linkTo('https://appgallery.cloud.huawei.com/ag/n/app/C107057313?locale=ru_RU')"></div>
          <div class="appButton" v-on:click="linkTo('https://apps.rustore.ru/app/ru.kari.android')"></div>
        </div>

        <img alt="" src="../assets/svg/bannerPart2.png" class="PC"/>

      </div>

    </div>

    <div class="faq" id="questions">
      <faq-component/>
    </div>

    <div class="footer align">

      <div>
        <div class="addr">
          <p>ООО МКК «ФИНМОЛЛ». ОГРН:1117746509638. ИНН: 7705954143</p>
          <p>Юридический адрес: 630112, Россия, г. Новосибирск, ул. Фрунзе, д. 242, помещение 406</p>
        </div>
        <div class="links">
          <a target="_blank" href="documents/ContractOfOrderForThePurchaseOfGoods.pdf">Договор поручения по приобретению и оплате товаров, работ и услуг</a><br>
          <a target="_blank" href="documents/attachmentToTheOrder.pdf">Соглашение о применении рекуррентных платежей по договорам поручения на оплату товара</a><br>
          <a target="_blank" href="documents/ConsentToAdvertising.pdf">Согласие на обработку персональных данных</a><br>
          <a target="_blank" href="documents/dd09a0a3dee1d63939834112ad0134d9.pdf">Политика обработки персональных данных</a>
        </div>
      </div>

      <div class="logo">
        <kari-logo-mobile/>
        <p>8 800 700 90 21</p>
        <a href="mailto: info@4kari.ru">info@4kari.ru</a>
      </div>

      <div class="end">
        <div class="buttons">
          <div class="appButton" v-on:click="linkTo('https://play.google.com/store/apps/details?id=ru.kari.android')"></div>
          <div class="appButton" v-on:click="linkTo('https://apps.apple.com/ru/app/kari-обувь-и-аксессуары/id1497875223')"></div>
          <div class="appButton" v-on:click="linkTo('https://appgallery.cloud.huawei.com/ag/n/app/C107057313?locale=ru_RU')"></div>
          <div class="appButton" v-on:click="linkTo('https://apps.rustore.ru/app/ru.kari.android')"></div>
        </div>
        <p>© «kari частями», 2025</p>
      </div>

    </div>

  </div>
</template>

<script>
import ShortDottedLine from '@/assets/svg/shortDottedLine';
import LongDottedLine from '@/assets/svg/longDottedLine';
import FaqComponent from '@/views/faq-component';
import KariLogoMobile from '@/assets/svg/kariLogoMobile';
export default {
  name: 'mainPage',
  components: { KariLogoMobile, FaqComponent, LongDottedLine, ShortDottedLine },
  methods: {
    scroll (value) {
      document.getElementById(value).scrollIntoView({ behavior: 'smooth' });
    },
    linkTo (value) {
      window.open(value);
    },
    setPopUp (val) {
      this.$store.commit('popUpVarChange', val);
    }
  }
};
</script>

<style scoped>

/*главная*/
#mainKari { position: relative }
#mainKari>.banner { background: url("../assets/svg/bannerMobile.png") no-repeat center center; background-size: cover; height: calc(160vw - 12vw); padding-top: 12vw }
#mainKari>.banner>.content { display: flex; flex-direction: column; align-items: center }
#mainKari>.banner>.content h1 { margin-bottom: 4.80vw }
#mainKari>.banner>.content p { margin-bottom: 11.20vw }
#mainKari>.banner>.content button { width: 100%; padding: 2.93vw 0 }

#mainKari>.advantages { margin: 10.67vw auto; width: 88vw; display: flex; flex-wrap: wrap; justify-content: space-between; }
#mainKari>.advantages>.advBlock { width: 40vw; display: flex; flex-direction: column; align-items: center; margin-bottom: 8vw }
#mainKari>.advantages>.advBlock>img { margin-bottom: 3.20vw }
#mainKari>.advantages>.advBlock>.title { font-weight: 700; margin-bottom: 1.07vw }
#mainKari>.advantages>.advBlock>.description { font-size: 4vw; text-align: center }

#mainKari>.parts>h2 { margin-bottom: 10.67vw }
#mainKari>.parts>img { width: 100% }
#mainKari>.parts>.part { margin-bottom: 10.67vw }
#mainKari>.parts>.part>img { width: 100%; }
#mainKari>.parts>.part>.num { font-size: 10.67vw; font-weight: 900; line-height: unset; font-family: 'inter'; color: rgba(45, 45, 45, 1) }
#mainKari>.parts>.part>.text>h3 { font-weight: 400; line-height: 6.40vw; margin-bottom: 5.33vw }
#mainKari>.parts>.part>.part2content>h3 { font-weight: 400; line-height: 6.40vw; margin-bottom: 5.33vw }
#mainKari>.parts>.part>.text>p { font-size: 4.27vw; margin-bottom: 3.20vw; line-height: 8vw }
#mainKari>.parts>.part>.text>p>a { font-weight: 700; color: rgba(153, 30, 102, 1); text-decoration-line: none }
#mainKari>.parts>.part>.part2content>.num { font-size: 10.67vw; font-weight: 900; line-height: unset; font-family: 'inter'; color: rgba(45, 45, 45, 1) }
#mainKari>.parts>.part>.text>.lh { line-height: 5.33vw }
#mainKari>.parts>.part>.text a { color: rgba(153, 30, 102, 1); font-weight: 700; font-size: 4.27vw }
#mainKari>.parts>.part>.text>.link { margin-bottom: 3.20vw }
#mainKari>.parts>.part>.part2content>.subParts>.subPart { border: solid 2px transparent;
  border-radius: 12px;
  background-image: linear-gradient(white, white),
  linear-gradient(to right, #FDCFF5, #FFCB95);
  background-origin: border-box;
  background-clip: padding-box, border-box; margin-bottom: 3.20vw; padding: 4.27vw }
#mainKari>.parts>.part>.part2content>.subParts>.subPart>h1 { margin-bottom: 3.20vw }
#mainKari>.parts>.part>.part2content>.subParts>.subPart>svg { margin-bottom: 3.20vw }
#mainKari>.parts>.part>.part2content>.subParts>.subPart>p { margin-bottom: 3.20vw }
#mainKari>.parts>.part>.part2content>.subParts>.subPart>a { font-size: 4.53vw; color: rgba(153, 30, 102, 1); font-weight: 700 }

#mainKari>.prilog { background-image: url("../assets/svg/prilaga.png"); height: calc(160vw - 5.33vw); padding-top: 5.33vw; background-size: cover; margin-bottom: 10.67vw }
#mainKari>.prilog>.prilCont>h2 { margin-bottom: 5.33vw }
#mainKari>.prilog>.prilCont>.points { padding-inline-start: 6.33vw; margin: 0 0 5.33vw 0 }
#mainKari>.prilog>.prilCont>.points>li { font-size: 4.27vw }

#mainKari>.faq { margin-bottom: 10.67vw }

#mainKari>.footer { padding: 6.40vw 0; border-top: 1px solid rgba(207, 207, 207, 1) }
#mainKari>.footer .addr { margin-bottom: 5.33vw }
#mainKari>.footer .addr>p { font-size: 3.47vw }
#mainKari>.footer .links { margin-bottom: 5.33vw }
#mainKari>.footer .links>a { color: rgba(153, 30, 102, 1); text-decoration-line: underline; margin-bottom: 2.13vw; font-size: 4.27vw }
#mainKari>.footer .logo { margin-bottom: 10.67vw }
#mainKari>.footer .logo>svg { margin-bottom: 3.20vw; width: 45.87vw; height: 8.53vw }
#mainKari>.footer .logo>p { font-size: 6.40vw; font-weight: 700; margin-bottom: 3.20vw }
#mainKari>.footer .logo>a { text-decoration-line: none; font-size: 4.80vw; color: rgba(0, 0, 0, 1); font-weight: 700 }
#mainKari>.footer .end>p { font-size: 4.80vw }

/*кнопки приложений*/
#mainKari .buttons { display: flex; flex-wrap: wrap; justify-content: space-between; }
#mainKari .buttons>.appButton { width: 44vw; height: 12.80vw; margin-bottom: 3.20vw }
#mainKari .buttons>.appButton:nth-child(1) { background: url("../assets/svg/googlePlay.svg") no-repeat center center; background-size: contain }
#mainKari .buttons>.appButton:nth-child(2) { background: url("../assets/svg/appStore.svg") no-repeat center center; background-size: contain }
#mainKari .buttons>.appButton:nth-child(3) { background: url("../assets/svg/appGallery.svg") no-repeat center center; background-size: contain }
#mainKari .buttons>.appButton:nth-child(4) { background: url("../assets/svg/ruStore.svg") no-repeat center center; background-size: contain }

@media screen and (min-width: 760px) {}

@media screen and (min-width: 1200px) {
  /*главная*/
  #mainKari {}
  #mainKari>.banner { background: url("../assets/svg/mainBannerFon.svg") no-repeat center center; height: calc(515px - 130px); padding-top: 130px; max-height: 515px}
  #mainKari>.banner>.content { display: flex; flex-direction: column; align-items: flex-start; position: relative }
  #mainKari>.banner>.content>.inner { width: 569px }
  #mainKari>.banner>.content>img { position: absolute; top: -130px; right: -113px }
  #mainKari>.banner>.content h1 { margin-bottom: 18px }
  #mainKari>.banner>.content p { margin-bottom: 42px }
  #mainKari>.banner>.content button { width: 250px; padding: 14px 0                                                   }

  #mainKari>.advantages { margin: 60px auto; width: 984px }
  #mainKari>.advantages>.advBlock { width: 201px; margin-bottom: 0 }
  #mainKari>.advantages>.advBlock>img { margin-bottom: 12px }
  #mainKari>.advantages>.advBlock>.title { font-weight: 700; margin-bottom: 4px }
  #mainKari>.advantages>.advBlock>.description { font-size: 18px; text-align: center }

  #mainKari>.parts>h2 { margin-bottom: 80px }
  #mainKari>.parts>.part { display: flex; margin-bottom: 40px }
  #mainKari>.parts>.part>img { width: 360px }
  #mainKari>.parts>.part>.num { font-size: 90px; font-weight: 900; line-height: unset; margin-right: 64px; width: 123px }
  #mainKari>.parts>.part>.text { width: 542px; margin-right: 71px }
  #mainKari>.parts>.part>.text>h3 { font-weight: 400; line-height: 38px; margin-bottom: 20px; font-size: 32px }
  #mainKari>.parts>.part>.part2content { display: flex; flex-direction: column; width: 100% }
  #mainKari>.parts>.part>.part2content>h3 { font-weight: 400; line-height: unset; margin-bottom: 20px; font-size: 32px }
  #mainKari>.parts>.part>.text>p { font-size: 20px; margin-bottom: 12px; line-height: unset }
  #mainKari>.parts>.part>.part2content>.num { font-size: 90px; font-weight: 900; line-height: unset; margin-right: 64px }
  #mainKari>.parts>.part>.text>.lh { line-height: 20px }
  #mainKari>.parts>.part>.text a { color: rgba(153, 30, 102, 1); font-weight: 700; font-size: 16px }
  #mainKari>.parts>.part>.text>.link { margin-bottom: 12px }
  #mainKari>.parts>.part>.part2content>.subParts { display: flex; justify-content: space-between; }
  #mainKari>.parts>.part>.part2content>.subParts>.subPart { margin-bottom: 12px; padding: 16px; width: calc(314px - 36px); height: calc(156px - 36px) }
  #mainKari>.parts>.part>.part2content>.subParts>.subPart>h1 { margin-bottom: 12px; font-size: 24px }
  #mainKari>.parts>.part>.part2content>.subParts>.subPart>svg { margin-bottom: 12px; width: 282px }
  #mainKari>.parts>.part>.part2content>.subParts>.subPart>p { margin-bottom: 12px; font-size: 15px }
  #mainKari>.parts>.part>.part2content>.subParts>.subPart>a { font-size: 17px; color: rgba(153, 30, 102, 1); font-weight: 700 }

  #mainKari>.prilog { height: calc(515px - 81px); padding-top: 81px; background: url("../assets/svg/mainBannerFon.svg") no-repeat center center; margin-bottom: 60px }
  #mainKari>.prilog>.prilCont { position: relative }
  #mainKari>.prilog>.prilCont>img { position: absolute; top: -81px; right: -150px }
  #mainKari>.prilog>.prilCont>h2 { margin-bottom: 29px; font-size: 42px }
  #mainKari>.prilog>.prilCont>.points { padding-inline-start: 32px; margin: 0 0 95px 0 }
  #mainKari>.prilog>.prilCont>.points>li { font-size: 16px }

  #mainKari>.faq {  margin-bottom: 60px }

  #mainKari>.footer { padding: 40px 0; display: flex; flex-wrap: wrap; justify-content: space-between }
  #mainKari>.footer .addr { margin-bottom: 20px }
  #mainKari>.footer .addr>p { font-size: 18px }
  #mainKari>.footer .links { margin-bottom: 40px }
  #mainKari>.footer .links>a { margin-bottom: 8px; font-size: 16px }
  #mainKari>.footer .logo { margin-bottom: 0; display: flex; flex-direction: column; align-items: flex-end }
  #mainKari>.footer .logo>svg { margin-bottom: 12px; width: 225px; height: 42px }
  #mainKari>.footer .logo>p { font-size: 32px; margin-bottom: 12px }
  #mainKari>.footer .logo>a { font-size: 24px }
  #mainKari>.footer .end { width: 100%; display: flex; justify-content: space-between; align-items: center }
  #mainKari>.footer .end>p { font-size: 18px }

  /*кнопки приложений*/
  #mainKari .buttons {justify-content: normal; flex-wrap: nowrap; z-index: 10; position: relative}
  #mainKari .buttons>.appButton { width: 161px; height: 48px; margin-bottom: 0; margin-right: 12px; cursor: pointer}
  #mainKari .buttons>.appButton:nth-child(1) { background: url("../assets/svg/googlePlay.svg") no-repeat center center; background-size: contain}
  #mainKari .buttons>.appButton:nth-child(2) { background: url("../assets/svg/appStore.svg") no-repeat center center; background-size: contain}
  #mainKari .buttons>.appButton:nth-child(3) { background: url("../assets/svg/appGallery.svg") no-repeat center center; background-size: contain}
  #mainKari .buttons>.appButton:nth-child(4) { background: url("../assets/svg/ruStore.svg") no-repeat center center; background-size: contain}
}

</style>
